import { Eye, EyeOff, RotateCcw } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { Separator } from '@/components/ui/separator'

interface TurnSnapshotActionProps {
  onRevert: () => void
  onCompareToggle?: () => void
  isReverting: boolean
  isComparing: boolean
  isComparingLoading: boolean
  isRevertDisabled?: boolean
  isActive?: boolean
  showOnlyReturn?: boolean
}

export function TurnSnapshotAction({
  onRevert,
  onCompareToggle,
  isReverting,
  isComparing,
  isComparingLoading,
  isRevertDisabled = false,
  isActive = false,
  showOnlyReturn = false,
}: TurnSnapshotActionProps) {
  return (
    <div className="w-full group/container">
      <div
        className={`relative flex items-center transition-opacity duration-200 ${
          isActive
            ? 'opacity-100'
            : 'opacity-0 group-hover/container:opacity-100'
        }`}
      >
        <Separator className="flex-1" />
        <div className="relative mx-2 flex items-center justify-center gap-2">
          {!showOnlyReturn && onCompareToggle && (
            <Button
              variant="ghost"
              size="sm"
              onClick={onCompareToggle}
              disabled={isComparingLoading || isReverting}
              className="text-[10px] p-0 hover:bg-transparent group/highlight-button flex items-center justify-center"
            >
              <div className="flex items-center">
                {isComparing ? (
                  <>
                    <EyeOff className="size-3" />
                    <span className="ml-1.5 whitespace-nowrap overflow-hidden transition-all duration-200 ease-in-out max-w-0 group-hover/highlight-button:max-w-[200px] pointer-events-none">
                      <span className="inline-block text-[10px]">
                        Remove highlights
                      </span>
                    </span>
                  </>
                ) : (
                  <>
                    <Eye className="size-3" />
                    <span className="ml-1.5 whitespace-nowrap overflow-hidden transition-all duration-200 ease-in-out max-w-0 group-hover/highlight-button:max-w-[200px] pointer-events-none">
                      <span className="inline-block text-[10px]">
                        Highlight changes
                      </span>
                    </span>
                  </>
                )}
              </div>
            </Button>
          )}
          <Button
            variant="ghost"
            size="sm"
            onClick={onRevert}
            disabled={isReverting || isRevertDisabled}
            className="text-[10px] p-0 hover:bg-transparent group/return-button-action flex items-center justify-center"
          >
            <div className="flex items-center">
              <RotateCcw className="size-3" />
              <span className="ml-1.5 whitespace-nowrap overflow-hidden transition-all duration-200 ease-in-out max-w-0 group-hover/return-button-action:max-w-[200px] pointer-events-none">
                <span className="inline-block text-[10px]">
                  {isActive ? 'Last snapshot selected' : 'Return to snapshot'}
                </span>
              </span>
            </div>
          </Button>
        </div>
        <Separator className="flex-1" />
      </div>
    </div>
  )
}
